
import { Component, Watch } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

import { Debounce } from 'vue-debounce-decorator'

import ToolbarComponent from '@/_components/bar/appToolbar/appToolbar.vue'
import SelectDashboard from '@/components/Select/dashboard.vue'
import FABComponent from '@/components/Button/FAB/FAB.vue'

import HSEInfoWidget from '@/views/Project/Dashboard/Component/HSEInfo/HSEInfo.vue'
import HSEInfoPublicWidget from '@/views/Project/Dashboard/Component/HSEInfoPublic/HSEInfoPublic.vue'

import HSEContactWidget from '@/views/Project/Dashboard/components/hseContact.vue'
import HSEDocumentWidget from '@/views/Project/Dashboard/components/hseDocument.vue'
import ObservationStatWidget from '@/views/Project/Dashboard/components/observationStatistics.vue'

import PersonnelStats from '@/views/Project/Dashboard/Component/PersonnelStats/PersonnelStats.vue'

import RichTextField from '@/components/RichTextField/richTextField.vue'
import EditorViewer from '@/components/EditorViewer/EditorViewer.vue'
import Dialog from '@/components/Dialog/Dialog.vue'

import { GridStack } from 'gridstack'
// @ts-ignore
import 'gridstack/dist/h5/gridstack-dd-native'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import router from '@/_router'

@Component({
    components: {
        ToolbarComponent,
        SelectDashboard,
        FABComponent,
        HSEInfoWidget,
        HSEInfoPublicWidget,
        HSEContactWidget,
        HSEDocumentWidget,
        ObservationStatWidget,
        RichTextField,
        EditorViewer,
        Dialog,
    },
    mixins: [ProjectMixin],
})
export default class ProjectDashboard extends Mixins<MixinInterface>(ProjectMixin) {
    dashboardLoading = true

    editorJSBlocks = [
        'header',
        'linkTool',
        'list',
        'embed',
        'quote',
        'table',
        'delimiter',
        'Marker',
        'underline',
    ]

    get project() {
        return this.$route.params.type == 'p'
            ? this.$store.getters.project(this.$route.params.id)
            : null
    }

    get group() {
        return this.$route.params.type == 'g'
            ? this.$store.getters.group(this.$route.params.id)
            : null
    }

    get dashboardId() {
        return this.$route.params.dashboardId
    }

    get dashboardBase() {
        return this.$store.getters.dashboard(this.dashboardId)
    }

    // UPDATE DASHBOARD
    dashboardPatchDialog = false
    dashboardPatchLoading = false

    dashboardValues = {
        name: '',
        description: null,
        isDefault: false,
    }

    @Watch('dashboardPatchDialog')
    toggleDashboardPatchDialog() {
        if (this.dashboardPatchDialog) {
            Object.keys(this.dashboardValues).map((key) => {
                this.dashboardValues[key] = this.dashboardBase[key]
            })
        }
    }

    async dashboardPatch() {
        try {
            this.dashboardPatchLoading = true
            const payload = {
                type: this.dashboardBase.type,
                id: this.dashboardBase.id,
                ...this.dashboardValues,
            }

            await this.patchDashboard(payload)

            this.dashboardPatchDialog = false
        } finally {
            this.dashboardPatchLoading = false
        }
    }

    // PUBLISH DIALOG
    publishDialog = false
    publishLoading = false

    async dashboardPublish() {
        try {
            this.publishLoading = true
            await this.publishDashboard(this.dashboardId)
            this.publishDialog = false
            this.dashboardPatchDialog = false
        } finally {
            this.publishLoading = false
        }
    }

    // DELETE DIALOG
    deleteDialog = false
    deleteLoading = false

    async dashboardDelete() {
        try {
            this.deleteLoading = true
            await this.deleteDashboard(this.dashboardId)
            let id = this.nextDashboard

            if (id) {
                this.$router.push({ name: 'dashboardId', params: { dashboardId: id } })
            } else {
                this.$router.push({ name: 'create-dashboard' })
            }
            this.deleteDialog = false
            this.dashboardPatchDialog = false
        } finally {
            this.deleteLoading = false
        }
    }

    // PATCH DIALOG
    updateLoading = false
    maxDashboardNameLength = 50

    get hasStagedChanges() {
        const dataBase = this.dashboardBase.data ? this.dashboardBase.data : JSON.stringify({})
        return JSON.stringify(this.widgets) != dataBase
    }

    async updateWidgetData() {
        if (!this.dashboardBase.constraints.data.writable) return
        try {
            this.updateLoading = true
            const payload = {
                type: this.dashboardBase.type,
                id: this.dashboardBase.id,
                data: JSON.stringify(this.widgets),
            }

            await this.patchDashboard(payload)
            this.initiateDashboard()
            if (this.to) {
                this.$router.push(this.to)
            }
            this.leaveDialog = false
        } finally {
            this.updateLoading = false
        }
    }

    // GRID STACK
    grid: any = null

    initiateGridStack() {
        this.emptyGrid()
        this.initiateGridContent()
    }

    initiateGridContent() {
        Object.values(this.widgets).forEach((element) => {
            this.initiateWidget(element)
        })
    }

    emptyGrid() {
        if (this.grid) {
            this.grid.removeAll()
        }
    }

    saveGrid() {
        let data = this.grid.save()
        let widgets = JSON.parse(JSON.stringify(this.$store.getters.widgetsData))

        data.forEach((item) => {
            let id = item.content.substring(
                item.content.indexOf('-') + 1,
                item.content.indexOf('">')
            )
            let placement = {}

            switch (this.viewType) {
                case 'mobile':
                    placement = {
                        mobile: {
                            x: item.x,
                            y: item.y,
                            h: item.h,
                            w: item.w,
                        },
                    }
                    break
                case 'tablet':
                    placement = {
                        tablet: {
                            x: item.x,
                            y: item.y,
                            h: item.h,
                            w: item.w,
                        },
                    }
                    break
                default:
                    placement = {
                        default: {
                            x: item.x,
                            y: item.y,
                            h: item.h,
                            w: item.w,
                        },
                    }
            }

            widgets[id].placement = { ...widgets[id].placement, ...placement }
        })

        this.$store.commit('widgetsData', widgets)
    }

    // WIDGET
    get viewType() {
        let result: any = null

        if (this.viewportWidth) {
            switch (true) {
                case this.viewportWidth < 760:
                    result = 'mobile'
                    break
                case this.viewportWidth < 1100:
                    result = 'tablet'
                    break
                case this.viewportWidth < 2000:
                    result = 'default'
                    break
                default:
                    result = 'default'
            }
        }

        return result
    }

    @Watch('viewType')
    gridViewChanged() {
        this.initiateGridStack()
    }

    mountComponent(data: any) {
        let instance: any = null
        let props = {
            component: data,
            dashboardId: this.dashboardId,
            project: this.project,
            group: this.group,
        } as any

        // Mapping widget types to their corresponding components
        const widgetMap = {
            HSEBoardWidget: HSEInfoWidget,
            HSEInfoWidget: HSEInfoWidget,
            HSEInfoPublicWidget: HSEInfoPublicWidget,
            HSEContactWidget: HSEContactWidget,
            HSEContactPublicWidget: HSEContactWidget,
            HSEDocumentWidget: HSEDocumentWidget,
            HSEDocumentPublicWidget: HSEDocumentWidget,
            ObservationStatWidget: ObservationStatWidget,
            PersonnelStatsWidget: PersonnelStats,
        }

        const widgetType = data.type

        // Check if the widgetType exists in the map
        if (widgetMap[widgetType]) {
            // Modify props conditionally based on the widget type
            if (widgetType.includes('Public')) {
                props = { ...props, isPublic: true }
            }

            instance = new (widgetMap[widgetType] as any)({
                propsData: props,
                i18n: this.$i18n,
                route: this.$route,
                store,
                vuetify,
                router,
            })
        }

        if (instance) {
            instance.dashboardId = this.dashboardId
            instance.$mount()
            return instance.$el
        } else {
            console.error(`Unsupported widget type: ${widgetType}`)
            return null
        }
    }

    get widgets() {
        return JSON.parse(JSON.stringify(this.$store.getters.widgetsData))
    }

    initiateWidget(data: any) {
        let div: any = document.createElement('div')
        div.id = `gsi-${data.id}`

        let placement = {
            ...(Number.isInteger(data.placement.default.w) && { w: data.placement.default.w }),
            ...(Number.isInteger(data.placement.default.h) && { h: data.placement.default.h }),
            ...(Number.isInteger(data.placement.default.minW) && {
                minW: data.placement.default.minW,
            }),
            ...(Number.isInteger(data.placement.default.minH) && {
                minH: data.placement.default.minH,
            }),
            ...(Number.isInteger(data.placement.default.x) && { x: data.placement.default.x }),
            ...(Number.isInteger(data.placement.default.y) && { y: data.placement.default.y }),
        }

        switch (this.viewType) {
            case 'mobile':
                Object.assign(placement, {
                    ...(Number.isInteger(data.placement.mobile.w) && {
                        w: data.placement.mobile.w,
                    }),
                    ...(Number.isInteger(data.placement.mobile.h) && {
                        h: data.placement.mobile.h,
                    }),
                    ...(Number.isInteger(data.placement.mobile.minW) && {
                        minW: data.placement.mobile.minW,
                    }),
                    ...(Number.isInteger(data.placement.mobile.minH) && {
                        minH: data.placement.mobile.minH,
                    }),
                    ...(Number.isInteger(data.placement.mobile.x) && {
                        x: data.placement.mobile.x,
                    }),
                    ...(Number.isInteger(data.placement.mobile.y) && {
                        y: data.placement.mobile.y,
                    }),
                })

                break
            case 'tablet':
                Object.assign(placement, {
                    ...(Number.isInteger(data.placement.tablet.w) && {
                        w: data.placement.tablet.w,
                    }),
                    ...(Number.isInteger(data.placement.tablet.h) && {
                        h: data.placement.tablet.h,
                    }),
                    ...(Number.isInteger(data.placement.tablet.minW) && {
                        minW: data.placement.tablet.minW,
                    }),
                    ...(Number.isInteger(data.placement.tablet.minH) && {
                        minH: data.placement.tablet.minH,
                    }),
                    ...(Number.isInteger(data.placement.tablet.x) && {
                        x: data.placement.tablet.x,
                    }),
                    ...(Number.isInteger(data.placement.tablet.y) && {
                        y: data.placement.tablet.y,
                    }),
                })
                break
        }

        this.grid?.addWidget({ ...placement, content: div.outerHTML })

        document.getElementById(div.id)?.appendChild(this.mountComponent(data))
    }

    get addedWidget() {
        return this.$store.getters.addWidget
    }

    @Watch('addedWidget')
    addWidget() {
        if (this.addedWidget) {
            this.$store.commit('widgetsData', {
                ...this.widgets,
                [this.addedWidget.id]: this.addedWidget,
            })
            this.initiateWidget(this.addedWidget)
            this.$store.commit('addWidget', null)
            this.saveGrid()
        }
    }

    get deletedWidget() {
        return this.$store.getters.deleteWidget
    }

    @Watch('deletedWidget')
    deleteWidget() {
        if (this.deletedWidget) {
            const element: any = document.getElementById(`gsi-${this.deletedWidget}`)?.parentElement
                ?.parentElement

            const widgetCopy = this.lodash.cloneDeep(this.widgets)
            delete widgetCopy[this.deletedWidget]
            this.$store.commit('widgetsData', { ...widgetCopy })
            this.grid.removeWidget(element)
            this.$store.commit('deleteWidget', null)
            this.saveGrid()
        }
    }

    // LIFESYCLES
    @Watch('dashboardId', { immediate: true })
    initLoadingDashboard() {
        this.dashboardLoading = true
    }

    @Watch('dashboardId', { immediate: true })
    @Debounce(200)
    async initiateDashboard() {
        if (!this.dashboardBase) return
        this.dashboardLoading = true
        const data = JSON.parse(this.dashboardBase.data)
        this.$store.commit('widgetsData', data ? data : {})
        this.initiateGridStack()
        this.dashboardLoading = false
    }

    mounted() {
        this.grid = GridStack.init({
            float: true,
            cellHeight: '10vh',
            minRow: 1,
            oneColumnModeDomSort: true,
            minWidth: 695,
        })

        this.grid?.on('change', (event, element) => {
            this.saveGrid()
        })
    }

    // // LEAVING GUARD
    leaveDialog = false
    to: any = null

    async beforeRouteLeave(to: any, from: any, next: any) {
        if (this.hasStagedChanges) {
            if (this.to) {
                next()
            } else {
                if (to.params.dashboardId == this.dashboardId) {
                    next()
                } else {
                    this.to = to
                    this.leaveDialog = true
                }
            }
        } else {
            next()
        }
    }

    closeDialog() {
        this.leaveDialog = false
        this.to = null
    }

    discardChanges() {
        this.leaveDialog = false
        this.$router.push(this.to)
    }

    navigateTo(data: any) {
        if (this.hasStagedChanges) {
            this.to = data
            this.leaveDialog = true
        } else {
            this.$router.push(data)
        }
    }
}
